import { render, staticRenderFns } from "./TwPagination.vue?vue&type=template&id=ff934352&scoped=true&"
import script from "./TwPagination.vue?vue&type=script&lang=js&"
export * from "./TwPagination.vue?vue&type=script&lang=js&"
import style0 from "./TwPagination.vue?vue&type=style&index=0&id=ff934352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff934352",
  null
  
)

export default component.exports